export default "__VITE_ASSET__577d3599__"